<!-- Center canvas: summary, text typed into directly, matches Main Banner's badge+card pattern -->
<div
  class="cr-pc-card"
  *ngIf="isPreview"
  [id]="block.blockId"
>
  <span class="cr-pc-badge">Intro + CTA</span>

  <span
    class="cr-pc-intro"
    [appInlineEdit]="block.variables?.IntroText ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert Intro Text"
    [inlineEditMultiline]="true"
    (inlineEditChange)="onChange($event, 'IntroText')"
  ></span>

  <a class="cr-pc-cta" [href]="previewHref" target="_blank" rel="noopener">
    <span
      [appInlineEdit]="block.variables?.MainCtaText ?? ''"
      [inlineEditBlockId]="block.blockId"
      [inlineEditPlaceholder]="ctaButtonPlaceholder"
      (inlineEditChange)="onChange($event, 'MainCtaText')"
    ></span>
  </a>
</div>

<!-- Right panel: real edit form -->
<div class="cr-pc-edit" *ngIf="!isPreview">
  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.IntroText ?? ''"
    (handleOnChange)="onChange($event, 'IntroText')"
    [placeholder]="introTextPlaceholder"
    [maxLength]="4000"
    variable="IntroText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.MainCtaText ?? ''"
    (handleOnChange)="onChange($event, 'MainCtaText')"
    [placeholder]="mainCtaTextPlaceholder"
    [maxLength]="30"
    variable="MainCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-pc-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.MainCtaLink ?? ''"
      (handleOnChange)="onChange($event, 'MainCtaLink')"
      [placeholder]="mainCtaLinkPlaceholder"
      [maxLength]="500"
      variable="MainCtaLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'MainCtaLinkSegmentRegex')"
      [selectedSegment]="block.variables?.MainCtaLinkSegmentRegex ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
